import React, {useCallback, useState, useContext, useMemo} from 'react';
import Popup from '../Popup/Popup';
import InteractionsList from "../Interactions/InteractionsList";
import Spinner from '../Spinner/Spinner';
import './PopupReady.scss';
import AppContext from "../../store";

const TEXT_LETS_GO = "Okay, lets go";

const PopupReady = () => {
	const {
		isConfiguratorAvailable,
		queueData: {index}
	} = useContext(AppContext);
	const [visible, setVisible] = useState(true);

	const disabled = useMemo(() => {
		return !(Number.isFinite(index) || isConfiguratorAvailable)
	}, [index, isConfiguratorAvailable])

	const onButtonClick = useCallback((e) => {
		if(disabled) return false;
		setVisible(false)
	}, [setVisible, disabled])

	return (
		<Popup
			name={'Ready'}
			title={'WILLKOMMEN'}
			visible={visible}
			className={'ready-popup'}
			onEscape={() => setVisible(false)}
		>
			<>
				<div className="text-blocks">
				<span className="text-block">
					<span className="text bold2">Bist Du bereit für die volle Montana Black Experience?</span>
					<span className="text">Erlebe und konfiguriere die GetOnMyLVL Editions interaktiv in Montes Gaming Room.</span>
				</span>
					<span className="text-block">
					<span className="text">
						Und das Beste daran? Du erstellst Deine ganz eigene Edition - nach Deinen Bedürfnissen, hautnah und in 3D.
					</span>
				</span>
				</div>
				<InteractionsList className={'interactions-list-inside-ready-popup'} />

				<button className={'ready-popup-button'} onClick={onButtonClick} disabled={disabled}>
					<span className={'ready-popup-value'}>{TEXT_LETS_GO}</span>
					<Spinner className={'ready-popup-spinner'} />
				</button>
			</>
		</Popup>
	);
};

export default PopupReady;